package com.fireavert.events.reboot_devices.client.presentation

data class RebootDeviceViewState(
    val loading: Boolean = false,
    val success: Boolean = false
)